<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break"><span>For Betty, my stepmother, because without her encouragement and her Harlequin Romances, I wouldn’t have written this story.</span></p>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span class="C_FirstWords">TO</span> Desi, because she had to deal with me editing this novel while my personal life wasn’t the best. She was patient with the missed deadlines and long periods of silence while I dealt with Real Life Issues.</p>
<p class="P_Normal">For Lynn and Poppy, when they announced the Dreamspun Desires line, jumped on my pitch with wonderful enthusiasm.</p>
<p class="P_Normal">And Elizabeth for starting this wonderful company; I’ve had a lovely time here, because she makes everyone feel like family.</p>
<p class="P_Normal">Lastly, Ed for his beta reading and support; all the mistakes are mine and not his. Tamazusa, Mason, and Phoenix gave up a lot of lap time and cuddles while I typed and edited my work—the poor kitties. Such are the sacrifices my kitties make for the written word.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?bc616d14